import React, { useEffect, useRef } from "react";

let leafletPromise = null;
function loadLeaflet() {
  if (window.L) return Promise.resolve();
  if (leafletPromise) return leafletPromise;
  leafletPromise = new Promise((resolve) => {
    const css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
    document.head.appendChild(css);
    const s = document.createElement("script");
    s.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    s.onload = resolve;
    document.body.appendChild(s);
  });
  return leafletPromise;
}

export function MapPane({ hotels, activeCode, formatPrice }) {
  const ref = useRef();
  const mapRef = useRef();
  const markers = useRef({});

  useEffect(() => {
    let cancelled = false;
    loadLeaflet().then(() => {
      if (cancelled || !ref.current) return;
      const L = window.L;
      if (!mapRef.current) {
        mapRef.current = L.map(ref.current, { zoomControl: true, scrollWheelZoom: false });
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution: "© OpenStreetMap",
          maxZoom: 18,
        }).addTo(mapRef.current);
      }
      const map = mapRef.current;
      Object.values(markers.current).forEach((m) => map.removeLayer(m));
      markers.current = {};
      const pts = [];
      const icon = L.divIcon({
        className: "",
        html: '<div style="background:#009E9E;width:16px;height:16px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>',
        iconSize: [16, 16], iconAnchor: [8, 16],
      });
      (hotels || []).forEach((h) => {
        const lat = parseFloat(h.latitude), lng = parseFloat(h.longitude);
        if (!lat || !lng) return;
        const price = h.minRate ? (formatPrice ? formatPrice(h.minRate) : "€" + Math.round(h.minRate)) : "Price on request";
        const mk = L.marker([lat, lng], { icon }).addTo(map);
        mk.bindPopup(`<b>${h.name || ""}</b><br/>${price}`);
        markers.current[h.code] = mk;
        pts.push([lat, lng]);
      });
      if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 14 });
      setTimeout(() => map.invalidateSize(), 200);
    });
    return () => { cancelled = true; };
  }, [hotels, formatPrice]);

  useEffect(() => {
    const mk = markers.current[activeCode];
    if (mk && mapRef.current) {
      mk.openPopup();
      mapRef.current.panTo(mk.getLatLng());
    }
  }, [activeCode]);

  return <div ref={ref} data-testid="map-pane" className="w-full h-full min-h-[300px] bg-[#E2E8F0]" />;
}
